<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">ユーザー編集</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-user />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUser from '../../../components/FormComponents/User'

export default {
  components: {
    FormUser,
  },
}
</script>

<style>
.list-name {
  font-size: 1.5rem;
}
</style>
